import { CONFIG } from '@/config/constants'

export function Access() {
  const { STORE } = CONFIG

  return (
    <section id="access" className="store-info">
      <div className="container">
        <h2 className="section-title">店舗情報・アクセス</h2>
        <div className="store-info-grid">
          <div className="info-card">
            <h3>店舗情報</h3>
            <div className="info-item">
              <strong>店名:</strong> {STORE.name}
            </div>
            <div className="info-item">
              <strong>運営:</strong> {STORE.company}
            </div>
            <div className="info-item">
              <strong>住所:</strong> {STORE.address}
            </div>
            <div className="info-item">
              <strong>電話:</strong>{' '}
              <a href={`tel:${STORE.phone}`}>{STORE.phone}</a>
            </div>
            <div className="info-item">
              <strong>Instagram:</strong>{' '}
              <a
                href={STORE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {STORE.instagram}
              </a>
            </div>
          </div>

          <div className="info-card">
            <h3>営業時間</h3>
            <div className="info-item">
              <strong>月〜金:</strong> 8:00 - 17:00
            </div>
            <div className="info-item">
              <strong>土日祝:</strong> 8:00 - 18:00
            </div>
            <div className="info-item">
              <strong>定休日:</strong> {STORE.hours.holiday}
            </div>
            <div className="info-item">
              <small>※営業カレンダーでご確認ください</small>
            </div>
          </div>
        </div>

        <div className="access-map">
          <h3>アクセス</h3>
          <div className="map-container">
            <div className="map-info">
              <p>
                <strong>住所:</strong> {STORE.address}
              </p>
            </div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3352.0980128815972!2d130.02886487598838!3d32.84265647363629!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35400324de4fa953%3A0x766199a48a75d718!2z6Kut5pep44OR44Oz5bel5oi_55-z56qv5Lq644GL44G%2B44KT44Gp!5e0!3m2!1sja!2sjp!4v1758815635367!5m2!1sja!2sjp"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="店舗地図"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  )
}
